/**
 * CareTeamPanel — Constellation members widget for subject dashboard.
 *
 * DRR-321: Extracted from SubjectDashboardPage for widget registry.
 */

import React from 'react';
import {
  Stack,
  Group,
  Text,
  Badge,
  Skeleton,
  Alert,
} from '@mantine/core';
import { IconUsers, IconUser } from '@tabler/icons-react';

import { useConstellationsByActorQuery } from '@/generated/graphql';
import type { WidgetProps } from '@ferp/core';

export function CareTeamPanel({ subjectActorId }: WidgetProps) {
  const { data, loading } = useConstellationsByActorQuery({
    variables: { actorId: subjectActorId },
    skip: !subjectActorId,
    fetchPolicy: 'cache-and-network',
  });

  const memberships = data?.constellationsByActor?.memberships ?? [];

  if (loading && memberships.length === 0) {
    return <Skeleton height={100} />;
  }

  if (memberships.length === 0) {
    return (
      <Alert icon={<IconUsers size={16} />} color="blue" variant="light">
        No care team assigned yet.
      </Alert>
    );
  }

  const ring1 = memberships.filter((m) => m.ring === 1);
  const ring2 = memberships.filter((m) => m.ring === 2);

  return (
    <Stack gap="xs">
      {ring1.length > 0 && (
        <>
          <Text size="xs" fw={600} c="dimmed">Care Team</Text>
          <Group gap="xs">
            {ring1.map((m, i) => (
              <Badge key={i} variant="light" color="blue" leftSection={<IconUser size={10} />}>
                {m.role}
              </Badge>
            ))}
          </Group>
        </>
      )}
      {ring2.length > 0 && (
        <>
          <Text size="xs" fw={600} c="dimmed" mt="xs">Authorities</Text>
          <Group gap="xs">
            {ring2.map((m, i) => (
              <Badge key={i} variant="light" color="violet" leftSection={<IconUser size={10} />}>
                {m.role}
              </Badge>
            ))}
          </Group>
        </>
      )}
    </Stack>
  );
}
